import { inject, Injectable, Type } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private readonly _nzModalService: NzModalService = inject(NzModalService);

  constructor() {}

  /**
   * Metodo che serve per creare una modale
   * @param component Componente da innestare dentro
   * @param width lunghezza della modale (int in px)
   * @param data dati da passare in input alla modale
   */
  openModal<T>(
    component: Type<NzSafeAny>,
    width: number,
    data?: T
  ): NzModalRef {
    const nzModal = this._nzModalService.create({
      nzContent: component,
      nzFooter: null,
      nzClosable: false,
      nzMaskClosable: false,
      nzCentered: true,
      nzWidth: width + 'px',
      nzClassName: 'custom-modal',
      nzData: data
    });

    return nzModal;
  }
}
